import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './AboutPage.css';

const AboutPage = () => {
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Marlo - About";
    }, []);

    // 处理城市卡片点击
    const handleCityClick = (cityName) => {
        // 跳转到EventPage并传递城市参数
        navigate('/event', { state: { selectedCity: cityName } });
    };

    return (
        <div className="about-page">
            <Header />
            
            {/* 背景图片 */}
            <div className="about-bg-header"></div>
            
            {/* 主要内容 */}
            <div className="about-content">
                {/* 第一行标题 */}
                <h1 className="about-main-title">
                    Everything Happening Around You
                </h1>
                
                {/* 第二行副标题 */}
                <p className="about-subtitle">
                    Deals worth walking for. Events worth showing up to. People worth meeting. All on Marlo.
                </p>
                
                {/* 功能卡片组 */}
                <div className="about-cards-container">
                    {/* 第一个卡片 */}
                    <div className="about-card">
                        <div className="about-card-header">
                            <img 
                                src={require('../images/about/user.png')} 
                                alt="User" 
                                className="about-card-icon"
                            />
                            <span className="about-card-title">Grab Deals Around the Corner</span>
                        </div>
                        <div className="about-card-description">
                            Local cafés, restaurants, and shops post exclusive deals daily. Claim in the app, walk in, save.
                        </div>
                    </div>
                    
                    {/* 分隔线 */}
                    <div className="about-divider"></div>
                    
                    {/* 第二个卡片 */}
                    <div className="about-card">
                        <div className="about-card-header">
                            <img 
                                src={require('../images/about/rocket.png')} 
                                alt="Rocket" 
                                className="about-card-icon"
                            />
                            <span className="about-card-title">Never Miss What’s Happening</span>
                        </div>
                        <div className="about-card-description">
                            Concerts, markets, club nights, study sessions — see every event near you and tap “I’m Going.”
                        </div>
                    </div>
                    
                    {/* 分隔线 */}
                    <div className="about-divider"></div>
                    
                    {/* 第三个卡片 */}
                    <div className="about-card">
                        <div className="about-card-header">
                            <img 
                                src={require('../images/about/flame.png')} 
                                alt="Flame" 
                                className="about-card-icon"
                            />
                            <span className="about-card-title">Find Someone to Go With</span>
                        </div>
                        <div className="about-card-description">
                            Post a plan or join someone else’s — coffee, gym, a night out. Tap “I’m In” and you’re set.
                        </div>
                    </div>
                </div>
            </div>

            {/* 第二个模块 */}
            <div className="about-second-section">
                <div className="about-second-content">
                    {/* PC端标题和描述 */}
                    <h2 className="about-second-title pc-only">
                        Post it in seconds. Be seen instantly.
                    </h2>
                    
                    <p className="about-second-description pc-only">
                        A few taps to post. Instant reach to everyone nearby on Marlo.
                    </p>
                    
                    {/* Pad端标题 */}
                    <div className="pad-title-group pad-only">
                        <div className="pad-title-line">Post it in seconds. Be seen</div>
                        <div className="pad-title-line">instantly.</div>
                    </div>
                    
                    {/* Pad端描述 */}
                    <div className="pad-description-group pad-only">
                        <div className="pad-description-line">A few taps to post.</div>
                        <div className="pad-description-line">Instant reach to everyone nearby on Marlo.</div>
                    </div>
                    
                    {/* Tab切换器 */}
                    <div className="tab-switcher">
                        {/* 蓝色光晕效果 */}
                        <div className="tab-glow-left"></div>
                        <div className="tab-glow-right"></div>
                        
                        {/* 绿色选中背景 */}
                        <div className={`tab-active-bg tab-position-${activeTab}`}></div>
                        
                        {/* Tab内容容器 */}
                        <div className="tab-content">
                            <div 
                                className={`tab-item ${activeTab === 0 ? 'active' : ''}`}
                                onClick={() => setActiveTab(0)}
                            >
                                <span className="tab-full-text">Instant Visibility</span>
                                <span className="tab-short-text">IV</span>
                            </div>
                            
                            <div className={`tab-divider ${(activeTab === 0 || activeTab === 1) ? 'hidden' : ''}`}></div>
                            
                            <div 
                                className={`tab-item ${activeTab === 1 ? 'active' : ''}`}
                                onClick={() => setActiveTab(1)}
                            >
                                <span className="tab-full-text">Targeted Reach</span>
                                <span className="tab-short-text">TR</span>
                            </div>
                            
                            <div className={`tab-divider ${(activeTab === 1 || activeTab === 2) ? 'hidden' : ''}`}></div>
                            
                            <div 
                                className={`tab-item ${activeTab === 2 ? 'active' : ''}`}
                                onClick={() => setActiveTab(2)}
                            >
                                <span className="tab-full-text">Effortless Posting</span>
                                <span className="tab-short-text">EP</span>
                            </div>
                        </div>
                    </div>

                    {/* Pad端专用内容 */}
                    <div className="pad-content pad-only">
                        {/* 卡片图片 */}
                        <div className="pad-card-image">
                            {activeTab === 0 && (
                                <img 
                                    src={require('../images/about/swiper1.png')} 
                                    alt="Instant Visibility" 
                                />
                            )}
                            {activeTab === 1 && (
                                <img 
                                    src={require('../images/about/swiper2.png')} 
                                    alt="Targeted Reach" 
                                />
                            )}
                            {activeTab === 2 && (
                                <img 
                                    src={require('../images/about/swiper3.png')} 
                                    alt="Effortless Posting" 
                                />
                            )}
                        </div>
                        
                        {/* 文字内容 */}
                        <div className="pad-text-content">
                            {activeTab === 0 && (
                                <>
                                    <div className="pad-text-title">
                                        <div className="pad-text-title-line">⚡ Publish in Seconds</div>
                                    </div>
                                    <div className="pad-text-description">
                                        Create and publish an event in just a few taps with no complicated setup.
                                    </div>
                                </>
                            )}
                            {activeTab === 1 && (
                                <>
                                    <div className="pad-text-title">
                                        <div className="pad-text-title-line">💬 Built-in Event Chat</div>
                                    </div>
                                    <div className="pad-text-description">
                                        Every event includes its own chat to help people connect before, during, and after.
                                    </div>
                                </>
                            )}
                            {activeTab === 2 && (
                                <>
                                    <div className="pad-text-title">
                                        <div className="pad-text-title-line">🌍 City-Wide Visibility</div>
                                    </div>
                                    <div className="pad-text-description">
                                        Skip flyers—just a few taps to publish and start getting signups.
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* 第三个模块 */}
                    <div className="about-third-section pc-only">
                        <div className="about-third-content">
                            <div className="about-third-left">
                                {activeTab === 0 && (
                                    <>
                                        <h3 className="about-third-title">
                                            ⚡ Publish in Seconds
                                        </h3>
                                        <p className="about-third-description">
                                            Create and publish an event in just a few taps with no complicated setup.
                                        </p>
                                    </>
                                )}
                                {activeTab === 1 && (
                                    <>
                                        <h3 className="about-third-title">
                                            💬 Built-in Event Chat
                                        </h3>
                                        <p className="about-third-description">
                                            Every event includes its own chat to help people connect before, during, and after.
                                        </p>
                                    </>
                                )}
                                {activeTab === 2 && (
                                    <>
                                        <h3 className="about-third-title">
                                            🌍 City-Wide Visibility
                                        </h3>
                                        <p className="about-third-description">
                                            Skip flyers—just a few taps to publish and start getting signups.
                                        </p>
                                    </>
                                )}
                            </div>
                            <div className="about-third-right">
                                {activeTab === 0 && (
                                    <img 
                                        src={require('../images/about/swiper1.png')} 
                                        alt="Instant Visibility" 
                                    />
                                )}
                                {activeTab === 1 && (
                                    <img 
                                        src={require('../images/about/swiper2.png')} 
                                        alt="Targeted Reach" 
                                    />
                                )}
                                {activeTab === 2 && (
                                    <img 
                                        src={require('../images/about/swiper3.png')} 
                                        alt="Effortless Posting" 
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 第四个模块 */}
            <div className="about-fourth-section">
                {/* PC端内容 */}
                <div className="pc-content pc-only">
                    {/* 右侧图片模块 */}
                    <div className="about-fourth-image"></div>
                    
                    {/* 文字内容模块 */}
                    <div className="about-fourth-text">
                        <h2 className="about-fourth-title">
                            See who's going and chat.
                        </h2>
                        <p className="about-fourth-description">
                            Discover the best local events on Marlo Explore and never go alone again.
                        </p>
                    </div>
                </div>
                
                {/* Pad端内容 */}
                <div className="pad-fourth-content pad-only">
                    {/* 图片 */}
                    <div className="pad-fourth-image">
                        <img 
                            src={require('../images/about/pad_card.png')} 
                            alt="Pad Card" 
                        />
                    </div>
                    
                    {/* 文字内容 */}
                    <div className="pad-fourth-text">
                        <div className="pad-fourth-title-group">
                            <div className="pad-fourth-title-line">See who's going</div>
                            <div className="pad-fourth-title-line">and chat.</div>
                        </div>
                        <div className="pad-fourth-description">
                            Discover the best local events on Marlo Explore and never go alone again.
                        </div>
                    </div>
                </div>
                
                {/* 手机端内容 */}
                <div className="mobile-fourth-content mobile-only">
                    {/* 图片 */}
                    <div className="mobile-fourth-image">
                        <img 
                            src={require('../images/about/m_card.png')} 
                            alt="Mobile Card" 
                        />
                    </div>
                    
                    {/* 文字内容 */}
                    <div className="mobile-fourth-text">
                        <div className="mobile-fourth-title-group">
                            <div className="mobile-fourth-title-line">Everything Happening</div>
                            <div className="mobile-fourth-title-line">Around You</div>
                        </div>
                        <div className="mobile-fourth-description-group">
                            <div className="mobile-fourth-description-line">Deals worth walking for. Events worth showing up to.</div>
                            <div className="mobile-fourth-description-line">People worth meeting. All on Marlo.</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 第五个模块 */}
            <div className="about-fifth-section">
                {/* PC端内容 */}
                <div className="about-fifth-image pc-only"></div>
                
                {/* Pad端内容 */}
                <div className="pad-fifth-content pad-only">
                    <img 
                        src={require('../images/about/bg3.png')} 
                        alt="Background 3" 
                    />
                </div>
                
                {/* 手机端内容 */}
                <div className="mobile-fifth-content mobile-only">
                    <img 
                        src={require('../images/about/bg4.png')} 
                        alt="Background 4" 
                    />
                </div>
            </div>

            {/* 第六个模块 */}
            <div className="about-sixth-section">
                <div className="about-sixth-content">
                    {/* 标题 */}
                    <div className="about-sixth-title-row">
                        <h2 className="about-sixth-title">Bringing Events to Your City</h2>
                    </div>

                    {/* 城市卡片容器 */}
                    <div className="about-sixth-cards">
                        <div className="about-sixth-cards-track">
                            {/* 第一组卡片 */}
                            <div className="about-sixth-card" onClick={() => handleCityClick('San Francisco')}>
                                <img src={require('../images/about/san_francisco.png')} alt="San Francisco" />
                            </div>

                            <div className="about-sixth-card" onClick={() => handleCityClick('New York City')}>
                                <img src={require('../images/about/new_york.png')} alt="New York City" />
                            </div>

                            <div className="about-sixth-card" onClick={() => handleCityClick('Las Vegas')}>
                                <img src={require('../images/about/las_vegas.png')} alt="Las Vegas" />
                            </div>

                            <div className="about-sixth-card" onClick={() => handleCityClick('Los Angeles')}>
                                <img src={require('../images/about/los_angeles.png')} alt="Los Angeles" />
                            </div>

                            <div className="about-sixth-card" onClick={() => handleCityClick('Miami')}>
                                <img src={require('../images/about/miami.png')} alt="Miami" />
                            </div>

                            {/* 第二组卡片（无缝循环） */}
                            <div className="about-sixth-card" onClick={() => handleCityClick('San Francisco')}>
                                <img src={require('../images/about/san_francisco.png')} alt="San Francisco" />
                            </div>

                            <div className="about-sixth-card" onClick={() => handleCityClick('New York City')}>
                                <img src={require('../images/about/new_york.png')} alt="New York City" />
                            </div>

                            <div className="about-sixth-card" onClick={() => handleCityClick('Las Vegas')}>
                                <img src={require('../images/about/las_vegas.png')} alt="Las Vegas" />
                            </div>

                            <div className="about-sixth-card" onClick={() => handleCityClick('Los Angeles')}>
                                <img src={require('../images/about/los_angeles.png')} alt="Los Angeles" />
                            </div>

                            <div className="about-sixth-card" onClick={() => handleCityClick('Miami')}>
                                <img src={require('../images/about/miami.png')} alt="Miami" />
                            </div>
                        </div>
                    </div>

                    {/* 左侧渐变遮罩 */}
                    <div className="about-sixth-gradient-left"></div>

                    {/* 右侧渐变遮罩 */}
                    <div className="about-sixth-gradient-right"></div>
                </div>
            </div>

            {/* 第七个模块 - Download */}
            <div className="fourth-section">
                <div className="fourth-content">
                    {/* Top notification */}
                    <div className="fourth-notification">
                    </div>
                    
                    {/* Main content */}
                    <div className="fourth-main">
                        <div className="fourth-title-group">
                            <div className="fourth-title-line1">
                                <span className="fourth-title-text">Download</span>
                                <span className="fourth-title-gradient">Marlo</span>
                            </div>
                            <div className="fourth-title-line2">Find your people nearby</div>
                        </div>
                        
                        <img 
                            src={require('../images/home/download.png')} 
                            alt="Download" 
                            className="fourth-download-icon"
                            onClick={() => window.open('https://apps.apple.com/us/app/marlo-connect-meet-nearby/id6450737280?l=zh-Hans-CN', '_blank')}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </div>
            </div>
            
            <Footer />
        </div>
    );
};

export default AboutPage;
